module.exports = __webpack_public_path__ + "img/content6-1.fa201e7d.webp";